const baseurl="https://contactssvegile.azurewebsites.net"
const guidBaseUrl = "https://sstvtv01.somee.com"

const postContactUrl =  guidBaseUrl + "/WebSite_Pilot"
const postJobRequestUrl =  guidBaseUrl + "/WebSite_Applicants"
const fileUploadUrl = baseurl + "/api/Contacts/SaveFile/contacts"
const resumeUploadUrl = baseurl + "/api/Contacts/SaveFile/resume"
const guidUrl = guidBaseUrl + "/website_tracking"

export { 
    postContactUrl, postJobRequestUrl, fileUploadUrl, resumeUploadUrl, guidUrl
} 